import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(() =>
  createStyles({
    root: {
      position: 'relative',
      paddingLeft: 32,
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'block',
        height: 16,
        width: 16,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='17' height='16' viewBox='0 0 17 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M8.5 0C4.1 0 0.5 3.6 0.5 8C0.5 12.4 4.1 16 8.5 16C12.9 16 16.5 12.4 16.5 8C16.5 3.6 12.9 0 8.5 0ZM7.7 4.5C7.7 4.1 8 3.7 8.5 3.7C9 3.7 9.3 4 9.3 4.5V8.4C9.3 8.8 9 9.2 8.5 9.2C8 9.2 7.7 8.9 7.7 8.4V4.5ZM8.5 12.2C8 12.2 7.6 11.8 7.6 11.4C7.6 10.9 8 10.5 8.5 10.5C9 10.5 9.3 10.9 9.3 11.4C9.3 11.8 8.9 12.2 8.5 12.2Z' fill='%23FF4A3B'/%3E%3C/svg%3E")`,
      },
    },
  })
);
